import { Directive, Input, ViewContainerRef, TemplateRef } from "@angular/core";

interface TotalByContext {
    $implicit: number;
  }

@Directive({
    selector: '[total]'
})

export class TotalByDirective {
    private _propName: string;

    @Input('totalFor') set for (value: string) {
        this._propName = value;
    }

    @Input() set totalOf (value: any) {
        this.viewRef.clear();

        const collection = Array.isArray(value) ? value : [];
        let total = 0;
        collection.forEach(
            (item, index) => {
                total += +item[this._propName];
            }
        );

        this.viewRef.createEmbeddedView(this.templateRef, {$implicit: total});
    }

    constructor(private readonly viewRef: ViewContainerRef,
                private readonly templateRef: TemplateRef<TotalByContext>) {
    }

}
